export const fullScreen = () => ({
	type: 'FULL_SCREEN'
});

export const regularScreen = () => ({
	type: 'REGULAR_SCREEN'
});


// WEBPACK FOOTER //
// ./src/actions/fullscreen.js